<template>
  <section class="page-tips">

    <div class="page-tip-label">查询方法及注意事项：</div>
    <div class="page-tip-wrap">
      <div class="page-tip">1、正确输入证书编号，例<span class="highlight">（JD00000001）</span>，点击查询。</div>
      <div class="page-tip">2、电话：<span class="highlight">0571-56551766</span>。</div>
      <div class="page-tip">3、查询时间：周一至周五9:00-16:30。</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageTips'
}
</script>
<style lang="stylus" scoped src="./page-tips.styl"></style>
